import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import sectiondata from "../../data/sections.json";
import parse from "html-react-parser";
//import { GetSearchBy_CityBy_Location } from "../../request/apiRquest";
import Chips from "react-chips";
import { useHistory } from "react-router-dom";
import { Select } from "antd";
import { GetLocalitiesList } from "../../request/apiRquest";
import { Option } from "antd/es/mentions";
import Localities from "../../JsonData/Localities.json"
import BuildingType from "../../JsonData/BuildingType.json"


const Banner = () => {

  let Localitydata = Localities.Localities;
  let buildingType = BuildingType.BuildingType

  let data = sectiondata.banner;

  const history = useHistory()

  // const [buildingTypeList, setBuildingTypeList] = useState([]);
  const [chips, setChips] = useState([]);
  const [propertyFor, setPropertyFor] = useState("1");
  const [selectBuildingType, setSelectedBuildingType] = useState("2");
  const [selectedConstructionType, setSelectedConstructionType] = useState("2");
  const [localities, setLocalities] = useState([]);
  const [selectLocality, setSelectedLocality] = useState('Locality')
  


  useEffect(() => {
    getlocalitylist();
  }, [])


  const getlocalitylist = () => {
    GetLocalitiesList().then((res) => {
      setLocalities(res);
      //  console.log(res);

    })
  }


  const getsearchbylocation = () => {
    // GetSearchBy_CityBy_Location().then((res) => {
    //   setSearchLocation()
    // })
  }

  useEffect((id, city) => {
    getsearchbylocation(id, city)
  }, [])


  const handleSearch = () => {
    const buildingTypeSlugs = {
      1: "apartment",
      2: "townhouse",
      4: "villas",
      5: "penthouse",
      6: "studio-apartment"
    };

    const constructionSlugs = {
      "1": "ready",
      "2": "offplan",
    }

    const typePath = propertyFor === "1" ? "buy" : "rent";
    const buildingTypePath = buildingTypeSlugs[selectBuildingType] || "";
    const constructionSlug = constructionSlugs[selectedConstructionType] || "offplan";
    // const slugifiedLocality = selectLocality?.replace(/\s+/g, '')?.toLowerCase();
    // const slugifiedLocality = selectLocality?.toLowerCase().replace(/\s+/g, '-');
    const slugifiedLocality =
  typeof selectLocality === "string" && selectLocality.trim() !== ""
    ? selectLocality.toLowerCase().replace(/\s+/g, '-')
    : "";



    if (typePath && buildingTypePath && constructionSlug && slugifiedLocality) {
      history.push(`/properties/${typePath}/${buildingTypePath}/${constructionSlug}/${slugifiedLocality}`);
    } else if (typePath && buildingTypePath && constructionSlug) {
      history.push(`/properties/${typePath}/${buildingTypePath}/${constructionSlug}`);
    } else if (typePath && buildingTypePath) {
      history.push(`/properties/${typePath}/${buildingTypePath}`);
    } else if (typePath) {
      history.push(`/properties/${typePath}`);
    } else {
      history.push(`/properties`);
    }
  }


  const inlineStyle = {
    //backgroundImage: "url(" + "/assets/img/banner/landing1.jpg)",
  };

  return (
    <div className="banner-area jarallax">
      <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: -1,
        }}
      >
        <source src="/assets/img/banner/Dubaiweb.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="container">
        <div className="banner-inner-wrap">
          <div className="row">
            <div className="col-12">
              <div className="banner-inner">
                {/* <h5 className="sub-title">{data.subtitle}</h5> */}
                <h1
                  className="title"
                  style={{
                    //textShadow: "2px 2px 8px rgba(255, 255, 255, 0.8)",
                    color: "white" // light glow
                  }}
                >
                  {data.title1} <br /> {data.title2}
                </h1>
              </div>
            </div>
            <div className="col-12">
              <div className="banner-search-wrap">
                <ul className="nav nav-tabs rld-banner-tab">
                  <li className="nav-item">
                    <a
                      className={`nav-link ${propertyFor === "1" ? "active" : ""}`}
                      onClick={() => setPropertyFor("1")}
                      style={{ cursor: "pointer", color: 'white' }}
                    >
                      Buy
                    </a>
                  </li>
                  <li className="nav-item" style={{
                    border: 'none'

                  }}>
                    <a className={`nav-link ${propertyFor === "2" ? "active" : ""}`}
                      onClick={() => setPropertyFor("2")}
                      style={{ cursor: "pointer", color: 'white' }}
                    >
                      Rent
                    </a>
                  </li>
                </ul>
                <div className="tab-content">
                  <div className="tab-pane fade show active" id="tabs_1">
                    <div className="rld-main-search" style={{
                      background: 'rgba(255, 255, 255, 0.2)',
                      boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
                      backdropFilter: ' blur(5px)',
                      WebkitBackdropFilter: 'blur(5px)',
                      // border:'1px solid rgba(255, 255, 255, 0.3'
                    }}>
                      <div className="row">
                        {/* <div className="col-xl-3 col-lg-6 col-md-6">
                          <div className="rld-single-input left-icon">
                            <Chips
                              value={chips}
                             // onChange={onChange}
                             // suggestions={suggestions}
                              placeholder="Search By Location & City"
                            />
                          </div>
                        </div> */}
                        <div className="col-xl-3 col-lg-6 col-md-6">
                          <div className="rld-single-select">
                            <select className="select single-select" value={selectBuildingType} onChange={(e) => setSelectedBuildingType(e.target.value)}>
                              {buildingType?.map((item) =>
                                <option key={item.id || item.name} value={item.id}>{item.name}</option>
                              )}
                              {/* <option value={1}>Property Type</option> */}
                            </select>
                          </div>
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-4">
                          <div className="rld-single-select">
                            <select className="select single-select" value={selectedConstructionType} onChange={(e) => setSelectedConstructionType(e.target.value)}>
                              <option value="0">Completion status</option>
                              <option value="1">Ready</option>
                              <option value="2">Off-plan</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6">
                          <div className="rld-single-select">
                            <select
                              className="select single-select"
                              showSearch
                              // style={{ width: 250, height: 50 }}
                              placeholder="Search Location"
                              optionFilterProp="label"
                              value={selectLocality}
                              onChange={(value) => setSelectedLocality(value)}
                              filterSort={(optionA, optionB) =>
                                (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                              }

                            >
                              {Localitydata?.map((loc) => (
                                <option key={loc.id} value={loc.locality_name} label={loc.locality_name}>
                                  {loc.locality_name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-xl-2 col-lg-4 col-md-4 readeal-top">
                          <button className="btn btn-yellow" onClick={handleSearch}>
                            SEARCH NOW
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

}

export default Banner;
